import { Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges } from '@angular/core';
import { BaseComponent } from '../../base/base.component';
import { TranslateService } from '@ngx-translate/core';

// Rename with Enum suffix.
export enum ClaroAlertTypeEnum {
  Negative = 0,
  Positive = 1,
  Warning = 2,
  Info = 3
}

interface ClaroAlertHtmlData {
   icon: string;
   class: string;
   textColor: string;
}

const alertTypeToCss: Map<number, ClaroAlertHtmlData> = new Map<number, ClaroAlertHtmlData>([
    [ClaroAlertTypeEnum.Negative, {"icon": "info", "class":  "claroAlert_negative", "textColor" : "#7A0C2E"}],
    [ClaroAlertTypeEnum.Warning, {"icon": "report_problem", "class":  "claroAlert_warning", "textColor" : "#D39E00"}],
    [ClaroAlertTypeEnum.Info, {"icon": "info", "class":  "claroAlert_info", "textColor" : "#04297A"}],
    [ClaroAlertTypeEnum.Positive, {"icon": "check_circle", "class":  "claroAlert_positive", "textColor" : "#08660D"}]
]);

// RBF - for testing, call the component from TeamMemberView component.
@Component({
  selector: 'claro-alert',
  templateUrl: './claro-alert.component.html',
  styleUrls: ['./claro-alert.component.css']
})
class ClaroAlertComponent extends BaseComponent implements OnInit {

  @Input() type: ClaroAlertTypeEnum;
  @Input() header: string;
  @Input() text: string;
  @Input() presentDetailsButton: boolean;
  @Input() presentDismissButton: boolean;
  @Input() dismissButtonText: string = '';
  @Input() hideIcon: boolean = false;
  @Input() hideHeader: boolean = false;
  @Input() detailsButtonText : string ="";

  @Output("seeAlertClicked") seeAlertEmitter = new EventEmitter();
  @Output("dismissAlertClicked") dismissAlertEmitter = new EventEmitter();

  icon: string;
  cssContainerClass: string;
  textColor: string;

  constructor(private translate: TranslateService) {
    super();
  };

  ngOnInit(): void {
    super.ngOnInit();

    this.setCss();
    if ( this.detailsButtonText == ""){
      this.detailsButtonText = this.translate.instant("claroAlert.showDetailsButtonDefaultText");
    }
  }

  private setCss() {
    const css = alertTypeToCss.get(this.type);
    if (!css) {
      throw new Error("Invalid ClaroAlertType: " + this.type);
    }
    this.icon = css["icon"];
    this.cssContainerClass = css["class"];
    this.textColor = css["textColor"];
  }

  onSeeAlertClicked() {
    this.seeAlertEmitter.emit();
  }

  onDismissAlertClicked() {
    this.dismissAlertEmitter.emit();
  }

}

export { ClaroAlertComponent, alertTypeToCss };
